const statementsFR = {
    "view": {
        "table": {
            "title": "Votre liste de relevés",
            "column": {
                "type": "Type",
                "year": "Année",
                "month": "Mois",
                "issue_year": "Ann. Émission",
                "issue_month": "Mois Émission",
                "description": "Description",
                "amount": "Montant",
                "status": "Statut",
                "details": "Détails",
                "overview": "Aperçu"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "label": {
                "status_open": "Ouvert",
                "status_paid": "Payé",
                "type_licensing": "Licences",
                "type_regular": "Régulier",
                "type_audio_mastering_services": "Mastering Audio - Services",
                "type_vinyl_earnings": "Revenus Vinyle",
                "type_offset": "Décalage",
                "type_not_known": "Inconnu",
                "month_january": "Janvier",
                "month_february": "Février",
                "month_march": "Mars",
                "month_april": "Avril",
                "month_may": "Mai",
                "month_june": "Juin",
                "month_july": "Juillet",
                "month_august": "Août",
                "month_september": "Septembre",
                "month_october": "Octobre",
                "month_november": "Novembre",
                "month_december": "Décembre"
            },
            "button": {
                "download": "Télécharger",
                "exportCsv": "Exporter CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        }
    }
};

export default statementsFR;